<template>
    <div class="arv-layout">
        <nav>
            <ArvMenu />
        </nav>

        <main>
            <router-view />
        </main>
    </div>
</template>

<script>
import ArvMenu from '@/components/arv/ArvMenu'

export default {
    name: 'ArvLayout',
    components: {
        ArvMenu,
    },
}
</script>

<style lang="scss" scoped>
.arv-layout {
    display: flex;
    width: 100%;
    height: 100%;
    background-color: #fff;
    overflow-y: auto;

    nav,
    main {
        height: 100%;
        overflow-y: auto;
    }

    nav {
        flex: 0 0 220px;
    }

    main {
        width: 100%;
        border-left: $style-border;
    }

    @include respond-to('for-mobile-down') {
        flex-direction: column;

        nav,
        main {
            width: 100%;
            overflow-y: visible;
        }

        nav {
            border-bottom: $style-border;
        }

        main {
            border-left: none;
        }
    }
}
</style>
